import React, { useState, Fragment } from 'react';
import { string, node } from 'prop-types';
import classNames from 'classnames/bind';

import styles from './PopinInfoContainer.module.scss';

const cx = classNames.bind(styles);

const PopinInfoContainer = (props) => {
  const { className, children } = props;
  const [isDisplayTooltip, setIsDisplayTooltip] = useState(false);

  return (
    <Fragment>
      <button
        type="button"
        onClick={() => {
          setIsDisplayTooltip(true);
        }}
        className={cx('button-question')}
      >
        ?
      </button>

      {isDisplayTooltip && (
        <div className={cx('root', className)}>
          <div
            className={cx('popin-bg')}
            onClick={() => {
              setIsDisplayTooltip(false);
            }}
          />
          <section className={cx('content')}>
            {children}

            <button
              type="button"
              className={cx('btn')}
              onClick={() => {
                setIsDisplayTooltip(false);
              }}
            >
              <span className={cx('icon-close')} />
            </button>
          </section>
        </div>
      )}
    </Fragment>
  );
};

PopinInfoContainer.propTypes = {
  children: node.isRequired,
  className: string,
};

PopinInfoContainer.defaultProps = {
  className: null,
};

export default PopinInfoContainer;



// WEBPACK FOOTER //
// ./src/containers/PopinInfoContainer/PopinInfoContainer.js